module.exports = __webpack_public_path__ + "img/connection-left-3.36cb1d05.png";